<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "EmployeeForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        agency_id: null,
        status_slug: "employee-active",
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      return {
        agency_id_options: this.$store.getters["agency/getAll"].selectOptions("id", [
          "internal_number",
          " - ",
          "name",
        ]),
        status_slug_options: this.$store.getters["status/getByGroup"]("employee").selectOptions(
          "status_slug",
          "name"
        ),
      };
    },
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            agency_id: item.agency ? item.agency.id : null,
            status_slug: item.status ? item.status.status_slug : null,
            release_date: item.release_date
              ? this.$moment(item.release_date).format("YYYY-MM-DD")
              : null,
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("agency/getAllForSelect");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Employee/EmployeeForm.vue